import { render, staticRenderFns } from "./pictureResultBok.vue?vue&type=template&id=4a5fcf93&"
import script from "./pictureResultBok.vue?vue&type=script&lang=js&"
export * from "./pictureResultBok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports